import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { InvoiceDetailsInterface } from '../types/invoice-details-interface';
interface useInvoiceDetailsInterface {
  invoiceId: number | null;
}
export const useInvoiceDetails = t0 => {
  const $ = _c(6);
  const {
    invoiceId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== invoiceId || $[2] !== user) {
    t2 = () => user && `/api/dashboard/affiliate-dashboard/purchase-invoice/${invoiceId}/status-details`;
    $[1] = invoiceId;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: invoiceDetails
  } = useControlledSwr(t2, fetcher, undefined, !!user && !!invoiceId);
  let t3;
  if ($[4] !== invoiceDetails) {
    t3 = {
      invoiceDetails
    };
    $[4] = invoiceDetails;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};